export default class ViewBooleanVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	defaultValue = false;
	fieldType = 'boolean';
	uiComponent = 'view-boolean-field';
	description = 'Se a value true or false';

	constructor()
	{
		
	}
}